import { render, staticRenderFns } from "./CreateTemplate.vue?vue&type=template&id=a1923ba2&scoped=true"
import script from "./CreateTemplate.vue?vue&type=script&lang=js"
export * from "./CreateTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplate.vue?vue&type=style&index=0&id=a1923ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1923ba2",
  null
  
)

export default component.exports